import React, {Component} from 'react';
import {HashRouter, Redirect, Route, Switch} from 'react-router-dom';
import PublicRoute from './Utils/PublicRoute'
// import { renderRoutes } from 'react-router-config';
import './App.scss';
import Login from './Login'
import {createGetRequest} from "Utils/Common";

const loading = () => <div className="animated fadeIn pt-3 text-center">Loading...</div>;
// Containers
const DefaultLayout = React.lazy(() => import('./containers/DefaultLayout'));


// Pages
class App extends Component {
  constructor(props) {
    super(props);
    this.state= {
      loggedIn: null
    }
  }

  logout = () => {
    createGetRequest('logout')
        .then(response => {
          if (response.data.success === true) {
            this.setState({
              loggedIn: false
            })
            document.title = "Portail Recouveo" ;
          } else {
            alert("Une erreur est survenue. Veuillez rafraichir la page.") ;
          }
        }).catch(error => {
          console.log(error);
    })
  }

  login = () => {
    this.setState({
      loggedIn: true
    })
  }
  render() {
    if (this.state.loggedIn === null) return loading() ;
    return ( <>
		 { this.state.isDev ? (
					<div className="devbanner">
						
					</div>
		):null}
      <React.Suspense fallback={loading()}>
        <HashRouter>
          <Switch>
            <PublicRoute path="/login" component={Login} loggedIn={this.state.loggedIn} isDev={this.state.isDev} setLogin={this.login} location={this.props.location}/>
            <Route path="/" name="Home"
                   render={(props) => this.state.loggedIn === true ? <DefaultLayout logout={this.logout} {...props}/> :
                     <Redirect to={{pathname: '/login', state: {from: props.location, setLogin: this.login}}}/>}
            />
          </Switch>
        </HashRouter>
      </React.Suspense>
      </>
    );
  }
  componentDidMount() {
    createGetRequest('get_isDev')
        .then(response => {
          this.setState({isDev: response.data.dev}) ;
        })
        .catch(function (error) {
          console.log(error) ;
        })
    createGetRequest('get_isLogged')
        .then(response => {
          if (response.data.success === true) {
            this.setState({loggedIn: true});
          } else {
            this.setState({loggedIn: false});
            document.title = "Portail Recouveo";
          }
        })
        .catch(function (error) {
          console.log(error) ;
        })
  }
}

export default App;
